/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "trash-closed-a827d47c--sprite",
  "use": "trash-closed-a827d47c--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"trash-closed-a827d47c--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-135.221 -38.197)\"><path d=\"M147.933,53.852h10.574V63a2.127,2.127,0,0,1-2.115,2.139h-6.344A2.127,2.127,0,0,1,147.933,63h0\" fill=\"currentColor\" /><path d=\"M159.226,51.111a.975.975,0,0,1-.96.97h-10.08a.971.971,0,0,1-.94-1,.959.959,0,0,1,.94-.94h3.63V49.6a1.4,1.4,0,1,1,2.8,0v.54h3.65A.962.962,0,0,1,159.226,51.111Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
